// iTRACE WMS — axios dedicato (token separato dal resto dell'app) + helpers
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const wmsApi = axios.create({ baseURL: API });
wmsApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("wms_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fmtKg = (n) => (n ?? 0).toLocaleString("it-IT", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
export const fmtKg2 = (n) => (n ?? 0).toLocaleString("it-IT", { maximumFractionDigits: 2 });
export const fmtEur = (n) => (n == null ? "—" : n.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €");
export const fmtDate = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "—");
export const fmtDateTime = (d) => (d ? `${fmtDate(d)} ${d.slice(11, 16)}` : "—");

// Apre un PDF autenticato in una nuova scheda (tab pre-aperta nel gesto utente
// per evitare i popup-blocker, poi riempita col blob)
export function openWmsPdf(path, preTab = null) {
  const tab = preTab || window.open("", "_blank");
  return wmsApi
    .get(path, { responseType: "blob" })
    .then((r) => {
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      if (tab) tab.location = url;
      else window.open(url, "_blank");
    })
    .catch(() => {
      if (tab) tab.close();
    });
}
